export const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);